import type { SVGProps } from 'react';
export const IconSocialsTaplink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2.15039C17.7196 2.15039 22.3496 6.78038 22.3496 12.5C22.3496 18.2196 17.7196 22.8496 12 22.8496C6.28038 22.8496 1.65039 18.2196 1.65039 12.5C1.65039 6.78038 6.28038 2.15039 12 2.15039ZM12 3.90234C7.24593 3.90234 3.40234 7.74593 3.40234 12.5C3.40234 17.2541 7.24593 21.0977 12 21.0977C16.7541 21.0977 20.5977 17.2541 20.5977 12.5C20.5977 7.74593 16.7541 3.90234 12 3.90234ZM16.6055 14.7812C17.0881 14.7814 17.4814 15.1755 17.4814 15.6582C17.4813 16.1408 17.088 16.5341 16.6055 16.5342H7.39453C6.91195 16.5341 6.51872 16.1408 6.51855 15.6582C6.51855 15.1755 6.91185 14.7814 7.39453 14.7812H16.6055ZM16.6055 11.624C17.0881 11.6241 17.4814 12.0173 17.4814 12.5C17.4814 12.9827 17.0881 13.3759 16.6055 13.376H7.39453C6.91185 13.3759 6.51855 12.9827 6.51855 12.5C6.51855 12.0173 6.91185 11.6241 7.39453 11.624H16.6055ZM16.6055 8.46582C17.088 8.46593 17.4813 8.85923 17.4814 9.3418C17.4814 9.8245 17.0881 10.2186 16.6055 10.2188H7.39453C6.91185 10.2186 6.51855 9.8245 6.51855 9.3418C6.51872 8.85923 6.91195 8.46593 7.39453 8.46582H16.6055Z"
      fill="currentColor"
    />
  </svg>
);
